module.exports = __webpack_public_path__ + "dist/media/logo--mute.24b39b1b.svg";